export const SIGNUPFORM = [
  {
    id: 1,
    label: "User Name",
    name: "username",
    type: "name",
    placeholder: "Enter your name",
  },
  {
    id: 2,
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Enter your organization email",
  },
  {
    id: 3,
    label: "Password",
    name: "password",
    type: "password",
    placeholder: "Enter your password",
  },
  {
    id: 4,
    label: "Confirm Password",
    name: "confirmPassword",
    type: "password",
    placeholder: "Enter your confirm password",
  },
];

export const SIGNINFORM = [
  {
    id: 1,
    label: "Email",
    name: "email",
    type: "email",
    placeholder: "Enter your email",
  },
  {
    id: 2,
    label: "Password",
    name: "password",
    type: "password",
    placeholder: "6+ Characters, 1 Capital letter",
  },
  {
    id: 3,
    label: "Remember me",
    name: "remember-me",
    type: "checkbox",
  },
];

export const ORGANIZATIONFIELDS = [
  {
    id: 1,
    label: "Organization Name",
    name: "organizationName",
    type: "name",
    placeholder: "Enter your organization name",
  },
  {
    id: 2,
    label: "Organization Roll",
    name: "organizationRoll",
    type: "name",
    placeholder: "Enter your organization roll",
  },
  {
    id: 3,
    label: "Mobile No",
    name: "mobileNumber",
    type: "tel",
    placeholder: "Enter your mobile no",
  },
  // {
  //   id:4,
  //   type: 'multiselect',
  //   fields:[
  //     {
  //       id: 1,
  //       label: "BaseURL",
  //       name: "defaultURL",
  //       type: "text",
  //       placeholder: "Enter your full domain url",
  //     },
  //     {
  //       id: 2,
  //       label: "Environment",
  //       name: "defaultEnv",
  //       type: "text",
  //       placeholder: "Please set environment for base url eg: 'testing' or 'production'",
  //     },
  //   ]
  // }
];

export const PASSWORDFIELDS = [
  {
    id: 1,
    label: "Password",
    name: "password",
    type: "password",
    placeholder: "Enter your password",
  },
  {
    id: 2,
    label: "Confirm Password",
    name: "confirmPassword",
    type: "password",
    placeholder: "Enter your confirm password",
  },
];

export const FEATURETABLE =  [
        {
            "pageName": "",
            "hostname": "",
            "url": "",
            "paidUserClicks": "0",
            "freeTrailsUsersClick": "0",
            "noOfUsersVisited": "0",
            "totalTimeSpent": "325943",
            "pageId": "",
            "avgTimeSpent": "162971.5",
            "lastTimeUsed": "3/1/2024 - 4:56:9 PM",
            "totalEvents": "1",
            "totalUsers": [
                "65952097bab45a1b0276f2ad",
                "65954444c299754ed8077875"
            ],
            "userInfo": [
                {
                    "userName": "",
                    "userEmail": "",
                    "paidFreeTrailUser": "",
                    "companyIndividual": "",
                    "totalEventsClicked": "",
                    "averageTimeSpentOnWebsite": "4172628.5",
                    "lastActivity": "3/1/2024 - 4:41:6 PM",
                    "totalFeaturesExplored": [],
                    "totalPagesExplored": [
                        "65952097bab45a1b0276f2ac"
                    ]
                },
            ]
        }
    ];

export const CUSTOMERTABLE = [
  {
    userName : 'string',
    paidFreeTrailUser : 'haunte',
    companyIndividual: 'haunte@gmail.com',
    totalFeaturesExplored: 'noOfUsersVisited',
    totalPagesExplored: '10',
    totalEventsClicked:'1h 48m ',
    averageTimeSpentOnWebsite: 'http://localhost:3000/dashboard/customers',
    lastActivity: '2023-12-26T12:32:16.993Z',
  },
  {
    userName : 'string',
    paidFreeTrailUser : 'haunte',
    companyIndividual: 'haunte@gmail.com',
    totalFeaturesExplored: 'noOfUsersVisited',
    totalPagesExplored: '139',
    totalEventsClicked:'1h 48m 36s',
    averageTimeSpentOnWebsite: 'http://localhost:3000/dashboard/customers',
    lastActivity: '2023-12-26T12:32:16.993Z',
  },
];

export const TABLEDATA = [
  // {
  //   pageName : 'string',
  //   user : 'haunte',
  //   addedTime:'jan 2',
  //   lastUpdatedTime: '12 hr ago',
  //   totalEvents: '32',
  // },
];
